import { get } from 'lodash';
import { AnalyticsTypes } from '../../../middleware/google-analytics';
import { BOOKING_SECTION_KEY } from './constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../EventTrackingConstants';
import { PROFILE_GA_CATEGORY } from '../../constants';
import { NEW_EXISTING_RADIO_STATE_KEY } from '@zocdoc/components/src/newexistingradio/NewExistingRadioSelector';

export const ActionTypes = {
    TRACK_CLICK_BOOKING_SECTION_HEADER: `${BOOKING_SECTION_KEY}/TRACK_CLICK_BOOKING_SECTION_HEADER`,
    TRACK_PROCEDURE_DROPDOWN_CLICK: `${BOOKING_SECTION_KEY}/TRACK_PROCEDURE_DROPDOWN_CLICK`,
    TRACK_PROCEDURE_DROPDOWN_CHANGE: `${BOOKING_SECTION_KEY}/TRACK_PROCEDURE_DROPDOWN_CHANGE`,
    TRACK_INTERACT_NEW_PATIENTTYPE: `${BOOKING_SECTION_KEY}/TRACK_INTERACT_NEW_PATIENTTYPE`,
    TRACK_INTERACT_EXISTING_PATIENTTYPE: `${BOOKING_SECTION_KEY}/TRACK_INTERACT_EXISTING_PATIENTTYPE`,
};

export const trackClickBookingSectionHeader = () => ({
    type: ActionTypes.TRACK_CLICK_BOOKING_SECTION_HEADER,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Book An Appointment Header',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.BOOK_AN_APPOINTMENT_HEADER,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.BOOK_AN_APPOINTMENT_HEADER,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickBookAnAppointmentHeader',
            },
        },
    },
});

export const trackProcedureDropdownClick = () => ({
    type: ActionTypes.TRACK_PROCEDURE_DROPDOWN_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Procedure Dropdown',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.VISIT_REASON,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.VISIT_REASON_DROPDOWN,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickVisitReasonDropdown',
            },
        },
    },
});

export const trackProcedureDropdownChange = procedure => ({
    type: ActionTypes.TRACK_PROCEDURE_DROPDOWN_CHANGE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Change Procedure',
            category: PROFILE_GA_CATEGORY,
            label: get(procedure, 'id'),
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.VISIT_REASON,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.VISIT_REASON_DROPDOWN,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'SelectVisitReason',
                EventDetails: { ProcedureId: get(procedure, 'id') },
            },
        },
    },
});

export const trackClickNewPatientType = () => ({
    type: ActionTypes.TRACK_INTERACT_NEW_PATIENTTYPE,
    meta: getNewExistingRadioTracking(
        'Click New Patient Type Radio Button',
        TARGETS.NEW_PATIENT,
        'ClickNewPatientTypeRadio',
        INTERACTION_TYPES.CLICK
    ),
});

export const trackClickExistingPatientType = () => {
    return (dispatch, getState) => {
        // Only dispatch if this switches the new patient toggle
        const state = getState();
        const { isNewPatient } = state[NEW_EXISTING_RADIO_STATE_KEY];
        if (isNewPatient) {
            dispatch({
                type: ActionTypes.TRACK_INTERACT_EXISTING_PATIENTTYPE,
                meta: getNewExistingRadioTracking(
                    'Click Existing Patient Type Radio Button',
                    TARGETS.EXISTING_PATIENT,
                    'ClickExistingPatientTypeRadio',
                    INTERACTION_TYPES.CLICK
                ),
            });
        }
    };
};

export const trackKeyDownNewPatientType = () => {
    return (dispatch, getState) => {
        // Only dispatch if this switches the new patient toggle
        const state = getState();
        const { isNewPatient } = state[NEW_EXISTING_RADIO_STATE_KEY];
        if (!isNewPatient) {
            dispatch({
                type: ActionTypes.TRACK_INTERACT_NEW_PATIENTTYPE,
                meta: getNewExistingRadioTracking(
                    'Key Down New Patient Type Radio Button',
                    TARGETS.EXISTING_PATIENT,
                    'KeyDownNewPatientTypeRadio',
                    INTERACTION_TYPES.TYPE
                ),
            });
        }
    };
};

export const trackKeyDownExistingPatientType = () => ({
    type: ActionTypes.TRACK_INTERACT_EXISTING_PATIENTTYPE,
    meta: getNewExistingRadioTracking(
        'Key Down Existing Patient Type Radio Button',
        TARGETS.EXISTING_PATIENT,
        'KeyDownExistingPatientTypeRadio',
        INTERACTION_TYPES.TYPE
    ),
});

const getNewExistingRadioTracking = (action, Element, EventAction, InteractionType) => ({
    analytics: {
        type: AnalyticsTypes.TrackEvent,
        action,
        category: PROFILE_GA_CATEGORY,
        data: {
            Section: TARGETS.BOOK_AN_APPOINTMENT,
            Component: TARGETS.NEW_EXISTING_PATIENT_TYPE_RADIO,
            InteractionType,
            Element,
            Initiator: EVENT_INITIATORS.USER,
            EventAction,
        },
    },
});
